export const actionItemStatuses = {
    1: {
        value: 1,
        label: 'Pending',
    },
    2: {
        value: 2,
        label: 'Complete',
    },
    3: {
        value: 3,
        label: 'Validated',
    },
};
